
export class SamlResponse {
    public destination: string;
    public notBefore: string;
    public notOnOrAfter: string;
    public subjectConfirmationData: string;
    public audience: string;
    public username: string;
    public email: string;
    public givenName: string;
    public surname: string;
    public callistaPersonId: string;
    public sapEmployeeNumber: string;
    public issuer: string;

    public groups: string;
    public roles: string;
    public isStaff: boolean;


    constructor(prefix: string) {
        this.destination = prefix + "/admin/saml2";
        this.subjectConfirmationData = prefix + "/admin/saml2";
        this.audience = prefix;
        this.username = "mjordan";
        this.email = "michael.jordan@idmqat.monash.edu";
        this.givenName = "Michael";
        this.surname = "Jordan";
        this.callistaPersonId = "";
        this.sapEmployeeNumber = "01000000";
        this.isStaff = true;
        this.issuer = "http://www.okta.com/exkf4if3catphTOtV0h7";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/SamlResponse.ts